function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "white",
  d: "M3 0.5C1.61929 0.5 0.5 1.61929 0.5 3V19C0.5 20.3807 1.61929 21.5 3 21.5H14C15.3807 21.5 16.5 20.3807 16.5 19V6.75621C16.5 6.14708 16.2776 5.5589 15.8746 5.10215L12.5603 1.34595C12.0857 0.808096 11.403 0.5 10.6857 0.5H3Z",
  stroke: "currentColor",
  strokeMiterlimit: 10
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M11 1V6C11 6.55228 11.4477 7 12 7H16",
  stroke: "currentColor",
  strokeMiterlimit: 10
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 11.5L6.68134 17.5L3.91211 14.5",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var SvgContractSigned = function SvgContractSigned(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgContractSigned, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/contract-signed.eff40350.svg";
export { ForwardRef as ReactComponent };